module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('section', [_c('p', {
    staticClass: "center firstInSection"
  }, [_c('i', [_vm._v("For the LORD thy God is a consuming fire.")])]), _vm._v(" "), _c('p', {
    staticClass: "right"
  }, [_vm._v("Deuteronomy 4:24"), _c('br'), _vm._v("\n(traditionally ascribed to Moses)")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-cbff5012","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/chapter2.vue
// module id = 69
// module chunks = 0